import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextQuestionStyles } from './textGroup.style';

export const TextGroup = ({ group }) => {
  const { t } = useTranslation();
  return <TextQuestionStyles>{t(group.text)}</TextQuestionStyles>;
};
